import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';

import { useAuth } from '../contexts/AuthContext';
import { useTenant } from '../contexts/TenantContext';
import { useTheme } from '../contexts/ThemeContext';
import { usePageActions } from '../contexts/PageActionsContext';
import { TenantSelector } from './TenantSelector';

export function Navigation() {
  const location = useLocation();
  const navigate = useNavigate();

  const { user } = useAuth();
  const { canUseWhatsWeb, canUseOfficialApi } = useTenant();
  const { theme, toggleTheme } = useTheme();
  const { getActions, getMetadata } = usePageActions();

  const menuItems = [
    ...(canUseWhatsWeb() ? [{
      path: '/whatsapp',
      label: 'Conexões',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
        </svg>
      )
    }] : []),
    // 🚧 TEMPORARIAMENTE DESABILITADO - Em desenvolvimento
    // ...(canUseWhatsWeb() ? [{
    //   path: '/grupos',
    //   label: 'Grupos',
    //   icon: (
    //     <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
    //       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
    //     </svg>
    //   )
    // }] : []),
    {
      path: '/contatos',
      label: 'Contatos',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
        </svg>
      )
    },
    {
      path: '/campanhas',
      label: 'Campanhas',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5.882V19.24a1.76 1.76 0 01-3.417.592l-2.147-6.15M18 13a3 3 0 100-6M5.436 13.683A4.001 4.001 0 017 6h1.832c4.1 0 7.625-1.234 9.168-3v14c-1.543-1.766-5.067-3-9.168-3H7a3.988 3.988 0 01-1.564-.317z" />
        </svg>
      )
    },
    ...(canUseOfficialApi() ? [{
      path: '/templates',
      label: 'Templates',
      icon: null as any // Will be determined dynamically during render
    }] : []),
    ...(['ADMIN', 'TENANT_ADMIN', 'SUPERADMIN'].includes(user?.role || '') ? [{
      path: '/usuarios',
      label: 'Usuários',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197m13.5-9a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z" />
        </svg>
      )
    }] : []),
    // Configurações ocultas para tenants comuns (USER) - apenas ADMIN, TENANT_ADMIN e SUPERADMIN veem
    ...(['ADMIN', 'TENANT_ADMIN', 'SUPERADMIN'].includes(user?.role || '') ? [{
      path: '/configuracoes',
      label: 'Configurações',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z" />
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
        </svg>
      )
    }] : []),
    ...(user?.role === 'SUPERADMIN' ? [{
      path: '/superadmin',
      label: 'Super Admin',
      icon: (
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.031 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
        </svg>
      )
    }] : [])
  ];

  // Menu horizontal (sempre ativo - sidebar desabilitada)
  return (
    <nav 
        className="horizontal-navigation w-full shadow-lg transition-colors"
        style={{ 
          backgroundColor: theme === 'dark' ? '#1E1E1F' : '#ffffff',
          borderBottom: theme === 'dark' ? '1px solid rgba(255, 255, 255, 0.1)' : '1px solid rgba(0, 0, 0, 0.1)'
        }}
      >
        <div className="px-6 py-4">
          <div className="flex items-center justify-between">
          {/* Menu Items - Horizontal */}
          <ul className="flex items-center space-x-3">
              {menuItems.map((item) => {
                // For SuperAdmin, match all sub-routes; for others, exact match
                const isActive = item.path === '/superadmin' 
                  ? location.pathname.startsWith('/superadmin')
                  : location.pathname === item.path;
                const metadata = isActive ? getMetadata(item.path) : null;
                
                // Special handling for Templates icon - check metadata for back icon
                let iconToRender = item.icon;
                let isBackIcon = false;
                if (item.path === '/templates') {
                  const templatesMetadata = getMetadata('/templates');
                  const showBackIcon = templatesMetadata?.showBackIcon;
                  isBackIcon = !!showBackIcon;
                  
                  if (showBackIcon) {
                    // Left arrow icon for back navigation
                    iconToRender = (
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-label="Voltar">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                      </svg>
                    );
                  } else {
                    // Default document icon
                    iconToRender = (
                      <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                      </svg>
                    );
                  }
                }
                
                // Handle back icon click for Templates
                const handleTemplatesClick = (e: React.MouseEvent) => {
                  if (item.path === '/templates' && isBackIcon) {
                    e.preventDefault();
                    // Dispatch custom event to clear selected inbox
                    window.dispatchEvent(new CustomEvent('templates:back'));
                    navigate('/templates');
                  }
                };
                
                return (
              <li key={item.path}>
                <Link
                  to={item.path}
                  onClick={handleTemplatesClick}
                      className={`group relative flex items-center gap-3 rounded-xl transition-all duration-300 ${
                        isActive
                          ? 'shadow-lg transform scale-105 px-4 py-2' 
                          : 'w-12 h-12 justify-center ' + (theme === 'dark'
                              ? 'text-white/80 hover:text-white hover:bg-white/15 hover:transform hover:scale-105'
                              : 'text-gray-700 hover:text-gray-900 hover:bg-gray-100 hover:transform hover:scale-105')
                  }`}
                      style={isActive ?
                        { 
                          backgroundColor: theme === 'dark' ? '#ffffff' : '#1E1E1F',
                          color: theme === 'dark' ? 'rgb(30, 30, 30)' : 'rgb(230, 230, 230)' 
                        } : undefined
                      }
                  title={item.label}
                >
                  <div className={`transition-all duration-300 ${
                        isActive ? 'scale-110' : 'group-hover:scale-110'
                  }`}>
                    {iconToRender}
                  </div>

                      {/* Expanded view for active item */}
                      {isActive && metadata && (
                        <div className="flex flex-col">
                          <span className="text-sm font-semibold whitespace-nowrap">
                            {metadata.title}
                          </span>
                          {metadata.subtitle && (
                            <span className="text-xs opacity-80 whitespace-nowrap">
                              {metadata.subtitle}
                            </span>
                          )}
                        </div>
                      )}

                      {/* Tooltip for non-active items */}
                      {!isActive && (
                        <div 
                          className="absolute top-14 left-1/2 transform -translate-x-1/2 text-sm py-2 px-3 rounded-lg opacity-0 group-hover:opacity-100 transition-all duration-300 pointer-events-none whitespace-nowrap z-50 shadow-xl"
                          style={{
                            backgroundColor: theme === 'dark' ? '#1f2937' : '#374151',
                            color: '#ffffff'
                          }}
                        >
                          <div 
                            className="absolute -top-1 left-1/2 transform -translate-x-1/2 w-2 h-2 rotate-45"
                            style={{
                              backgroundColor: theme === 'dark' ? '#1f2937' : '#374151'
                            }}
                          ></div>
                    {item.label}
                  </div>
                      )}
                </Link>
              </li>
                );
              })}
          </ul>

            {/* Right Section: Theme Toggle + Tenant + User + Page Actions */}
            <div className="flex items-center gap-6">
              {/* Theme Toggle - Iframe Mode */}
              <button
                onClick={toggleTheme}
                className={`group relative flex items-center justify-center w-12 h-12 rounded-xl transition-all duration-300 hover:transform hover:scale-105 ${
                  theme === 'dark'
                    ? 'text-white/80 hover:text-white hover:bg-white/15'
                    : 'text-gray-700 hover:text-gray-900 hover:bg-gray-100'
                }`}
                title={theme === 'dark' ? 'Tema claro' : 'Tema escuro'}
              >
                {theme === 'dark' ? (
                  // Ícone de Sol
                  <svg className="w-5 h-5 transition-all duration-300 group-hover:scale-110" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z" />
                  </svg>
                ) : (
                  // Ícone de Lua
                  <svg className="w-5 h-5 transition-all duration-300 group-hover:scale-110" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z" />
                  </svg>
                )}

                {/* Tooltip */}
                <div 
                  className="absolute top-14 left-1/2 transform -translate-x-1/2 text-sm py-2 px-3 rounded-lg opacity-0 group-hover:opacity-100 transition-all duration-300 pointer-events-none whitespace-nowrap z-50 shadow-xl"
                  style={{
                    backgroundColor: theme === 'dark' ? '#1f2937' : '#374151',
                    color: '#ffffff'
                  }}
                >
                  <div 
                    className="absolute -top-1 left-1/2 transform -translate-x-1/2 w-2 h-2 rotate-45"
                    style={{
                      backgroundColor: theme === 'dark' ? '#1f2937' : '#374151'
                    }}
                  ></div>
                  {theme === 'dark' ? 'Tema claro' : 'Tema escuro'}
                </div>
              </button>

              {/* Tenant Selector - Iframe Mode */}
              <TenantSelector />

              {/* User Profile - Iframe Mode */}
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 rounded-full flex items-center justify-center" style={{ 
                  backgroundColor: theme === 'dark' ? 'rgba(255, 255, 255, 0.15)' : 'rgba(0, 0, 0, 0.1)' 
                }}>
                  <span className={`text-sm font-medium ${
                    theme === 'dark' ? 'text-white' : 'text-gray-700'
                  }`}>
                    {user?.nome?.charAt(0)?.toUpperCase() || 'U'}
                  </span>
                </div>
                <div>
                  <p className={`text-sm font-medium ${
                    theme === 'dark' ? 'text-white' : 'text-gray-900'
                  }`}>
                    {user?.nome || 'Usuário'}
                  </p>
                  <p className={`text-xs ${
                    theme === 'dark' ? 'text-gray-400' : 'text-gray-600'
                  }`}>
                    {user?.role === 'ADMIN' ? 'Administrador' : user?.role === 'SUPERADMIN' ? 'Super Administrador' : 'Usuário'}
                  </p>
                </div>
              </div>

              {/* Page Actions - Iframe Mode */}
              {(() => {
                const pageActions = getActions(location.pathname);
                return pageActions ? (
                  <div className="flex items-center gap-2">
                    {pageActions}
                  </div>
                ) : null;
              })()}
            </div>
          </div>
        </div>
      </nav>
  );
}